/* RESPONSIBLE TEAM: team-proactive-support */

export enum DataType {
  ARTICLES = 0,
  OUTBOUND = 1,
}
